export const DEFAULT_LANGUAGE = "en";

export const SUPPORTED_LANGUAGES = ["en", "pt-BR", "de", "ru", "fr", "es"] as const;

type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export function isSupportedLanguage(value: string | null | undefined): value is SupportedLanguage {
  return value === "en" || value === "pt-BR" || value === "de" || value === "ru" || value === "fr" || value === "es";
}

export function resolveEffectiveLanguage(preference: string | null | undefined): SupportedLanguage {
  if (isSupportedLanguage(preference)) return preference;

  return DEFAULT_LANGUAGE;
}
